import { render, staticRenderFns } from "./parametrosPagamentoForm.vue?vue&type=template&id=6b8fa748&"
import script from "./parametrosPagamentoForm.vue?vue&type=script&lang=js&"
export * from "./parametrosPagamentoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports